const es = {

    // Navigation
    home: 'Inicio',
    marketplace: 'Marketplace',
    products: 'Productos',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    register: 'Registrarse',
    myAccount: 'Mi cuenta',
    adminPanel: 'Panel de administración',
    cart: 'Carrito',
    
    // Hero Section
    heroTitle: 'La plataforma digital #1 del Caribe',
    heroSubtitle: 'Compra tarjetas de regalo, recargas de juegos, suscripciones y servicios digitales con entrega instantánea',
    heroSlide2Title: 'Entrega digital instantánea',
    heroSlide2Subtitle: 'Recibe tus códigos al instante después del pago',
    heroSlide3Title: 'Los mejores precios garantizados',
    heroSlide3Subtitle: 'Los precios más competitivos para todos los productos digitales',
    exploreProducts: 'Explorar productos',
    shopNow: 'Comprar ahora',
    downloadApp: 'Descargar app',
    installApp: 'Instalar app',
    installAppHint: 'Para instalar: abre el menú de Chrome (⋮) y toca “Instalar aplicación” o “Añadir a pantalla de inicio”.',
    appInstalledToast: '¡KayiCom está instalada! Ábrela desde tu pantalla de inicio.',
    apkDownloadStarted: 'Descargando el APK. Abre el archivo y toca Instalar.',
    appUpdateTitle: 'Actualización disponible',
    appUpdateMessage: 'Hay una nueva versión de KayiCom. Actualiza ahora para obtener las últimas mejoras.',
    appUpdateLater: 'Más tarde',
    appUpdateNow: 'Actualizar ahora',
    appUpdateInstalling: 'Descargando actualización…',
    appUpdatePermission: 'Permite que KayiCom instale actualizaciones y vuelve a intentarlo.',
    appUpdateFailed: 'Error al actualizar. Inténtalo de nuevo.',
    appUpdateManualHint: 'Abre esta página en Chrome, descarga e instala el nuevo APK de KayiCom una vez. Las próximas actualizaciones se instalarán desde la app.',
    appUpdateVersionLine: 'Tienes v{local} → v{remote}',
    appUpdatePlayProtectHint: 'Si Play Protect bloquea la instalación, elige Instalar de todos modos.',
    getStarted: 'Empezar',
    
    // Features
    instantDelivery: 'Entrega instantánea',
    instantDeliveryDesc: 'Códigos entregados en segundos',
    securePayment: 'Pago seguro',
    securePaymentDesc: 'Transacciones protegidas',
    support247: 'Soporte 24/7',
    support247Desc: 'Ayuda cuando la necesites',
    competitivePrice: 'Precios competitivos',
    competitivePriceDesc: 'La mejor relación calidad-precio garantizada',
    
    // Homepage
    bestsellerLabel: 'Más vendidos',
    bestSellingProducts: 'Productos más vendidos',
    categoryDeals: 'Ofertas destacadas',
    viewAll: 'Ver todo',
    latestBlogPosts: 'Últimas publicaciones del Blog',
    visitBlog: 'Visitar Blog',
    salesCount: 'vendidos',
    noProductsAvailable: 'No hay productos disponibles',
    totalProducts: 'Productos',
    totalSales: 'Ventas',
    totalCategories: 'Categorías',

    // Blog
    blog: 'Blog',
    blogSubtitle: 'Guías, anuncios y consejos sobre productos digitales y streaming',
    blogFeatured: 'Destacado',
    readMore: 'Leer más',
    readArticle: 'Leer artículo',
    backToBlog: 'Volver al Blog',
    loadingPosts: 'Cargando publicaciones...',
    loadingPost: 'Cargando artículo...',
    noBlogPosts: 'Aún no hay publicaciones en el Blog.',
    postNotFound: 'Este artículo no está disponible.',
    minRead: 'min de lectura',
    relatedArticles: 'Artículos relacionados',
    allArticles: 'Todos los artículos',

    // Products
    allProducts: 'Todos los productos',
    productsSubtitle: 'Encuentra las mejores ofertas digitales al instante.',
    noProductsInCategory: 'No hay productos disponibles en esta categoría',
    noProductsYet: 'Aún no hay productos.',
    showingResultsFor: 'Mostrando resultados para',
    itemsCount: 'artículos',
    allCategories: 'Todos',

    // Top-Up
    topupHeroTitle: 'Recarga de juegos',
    topupHeroSubtitle: 'Recarga Free Fire LATAM y Delta Force — entregado al instante en tu cuenta.',
    topupPlayerVerify: 'Verificación de Player ID',
    topupPlayerVerifyDesc: 'Verificamos tu ID antes de la entrega',
    topupAutoDelivery: 'Entrega automática',
    topupAutoDeliveryDesc: 'Créditos entregados en minutos',
    browseByGame: 'Explorar por juego',
    allGames: 'Todos los juegos',
    otherGames: 'Otros juegos',
    howItWorks: 'Cómo funciona',
    topupStep1: 'Elige tu juego y paquete',
    topupStep2: 'Selecciona un paquete e ingresa tu Player ID',
    topupStep3: 'Paga de forma segura y recibe al instante',
    topupIdDialogDesc: 'Ingresa tu ID del juego para continuar. Es necesario para la entrega.',
    topupSelectPackage: 'Selecciona un paquete',
    topupPackages: 'paquetes',
    topupBuy: 'Comprar',
    topupOfficialBadge: 'Recarga oficial',
    topupProductSubtitle: '¡Elige un paquete y recarga tu cuenta!',
    topupVerifyPlayerId: 'Verificar Player ID',
    topupSelected: 'Paquete seleccionado',
    topupSearchGames: 'Buscar juegos...',
    topupPopularGames: 'Populares',
    topupSelectGame: 'Elige tu juego',
    topupInstantBadge: 'Instantáneo',
    topupPopularSection: 'Populares',
    topupDirectSection: 'Recarga directa',
    topupBestSellers: 'Los más vendidos',
    topupBestSellerBadge: 'Más vendido',
    topupBrowseAll: 'Todos los paquetes',
    topupStepEnterId: 'Ingresa tu Player ID',
    topupSelectTopUp: 'Selecciona recarga',
    topupContinueCheckout: 'Continuar al pago',
    topupViewAll: 'Ver todo',
    topupTrending: 'Tendencias',
    backToGames: 'Volver a juegos',
    playerName: 'Nombre del jugador',
    fromPrice: 'Desde',
    noTopupPackages: 'Aún no hay paquetes para este juego.',
    viewGamePage: 'Abrir página del juego',

    // Subscriptions
    subscriptionHeroTitle: 'Suscripciones Premium',
    subscriptionHeroSubtitle: 'Netflix, Spotify, Disney+, YouTube Premium y más — activados rápido a precios inmejorables.',
    subscriptionInstantDesc: 'Acceso entregado en minutos',
    subscriptionRenewLabel: 'Planes flexibles',
    subscriptionRenewDesc: 'Elige la duración que más te convenga',
    subscriptionStep1: 'Elige tu suscripción y la duración del plan',
    subscriptionStep2: 'Paga de forma segura con tu método preferido',
    subscriptionStep3: 'Recibe tus datos de acceso y disfruta',
    editPlayerId: 'Cambiar Player ID',
    saveAndContinue: 'Guardar y continuar',
    playerIdRequired: 'Player ID es obligatorio',
    idSaved: 'ID guardado',
    verifyingId: 'Verificando...',
    idVerified: 'ID verificado',
    floatingAnnouncementLabel: 'Aviso',
    floatingAnnouncementDismiss: 'Entendido',

    // NatCash payment
    natcashPaymentTitle: 'Pago con NatCash',
    natcashAccountName: 'Nombre de la cuenta',
    natcashPhone: 'Número NatCash',
    natcashAmount: 'Monto a enviar',
    natcashReference: 'Código de referencia (poner en Contenido)',
    natcashWaitingPayment: 'Esperando el pago',
    natcashHowToPay: 'Cómo pagar con NatCash:',
    natcashStep1: 'Marca *202# en tu teléfono',
    natcashStep2: 'Elige Transferir',
    natcashStep3: 'Ingresa el monto exacto mostrado arriba',
    natcashStep4: 'En el campo Contenido, ingresa el código de referencia mostrado arriba',
    natcashStep5: 'Ingresa tu PIN de NatCash',
    natcashStep6: 'Presiona Enviar para completar el pago',
    natcashPhoneWarning: 'El número de teléfono desde el que envías debe coincidir con el que usaste al hacer el pedido.',
    natcashVerifyNow: 'VERIFICAR AHORA',
    natcashSmsCountdown: 'Esperando el SMS',
    natcashAutoCheck: 'El sistema verifica automáticamente cada 10 segundos',
    natcashAutoPayHint: 'Envíe el monto exacto y ponga el código de referencia en Kontni — confirmación automática.',
    natcashVerifying: 'Verificando...',
    natcashCopy: 'COPIAR',
    natcashCopied: '¡Copiado!',
    natcashAutoPayment: 'Pago automático — NatCash/Natcom',
    natcashTotalHtg: 'Total NatCash (HTG)',
    paymentConfirmed: '¡Pago confirmado!',
    paymentConfirmedPreparingDelivery: 'Pago confirmado. Estamos preparando tu entrega. Vuelve a abrir esta página para verla.',
    autoDeliveryPendingHint: 'Hemos recibido tu pedido y lo estamos procesando. Espera mientras completamos la entrega.',

    transcodeLabel: 'Transcode',
    transcodePayHint: 'Pague el monto exacto de arriba y pegue el Transcode del SMS de pago abajo.',
    moncashPayHint: 'Paga el monto exacto con tu número MonCash (509 + 8 dígitos) — la confirmación es automática según tu número y el monto, no se necesita Transcode.',
    moncashOrderCreated: '¡Pedido creado! Paga el monto exacto con tu número MonCash — la confirmación es automática según tu número y el monto.',
    moncashTopupCreated: '¡Recarga creada! Paga el monto exacto con tu número MonCash — la confirmación es automática según tu número y el monto.',
    transcodeSmsNote: 'Después de pagar, NatCash envía un SMS de confirmación a su teléfono. El Transcode está en ese mensaje — cópielo y péguelo en el campo de abajo.',
    transcodePlaceholder: 'ej. 26082105770513',
    transcodeEnterHint: 'Ingrese el Transcode del SMS de NatCash',
    transcodeVerify: 'Verificar monto + Transcode',
    transcodeVerifying: 'Verificando monto + Transcode…',
    transcodeApproved: 'Pago confirmado.',

    // MonCash payment
    moncashAutoPayment: 'Pago MonCash automático (HTG)',
    moncashMinPurchase: 'Compra mínima',
    moncashNeedMore: 'te faltan',
    moncashNeedMoreSuffix: 'más',
    moncashFee: 'Comisión MonCash',
    natcashFee: 'Comisión NatCash',
    htgPaymentFee: 'Comisión de pago',
    moncashFeeOnOrder: 'en este pedido',
    moncashMinimum: 'Mínimo MonCash',
    moncashTotalWithFee: 'Total con comisión',
    moncashAmountToPay: 'Monto a pagar en MonCash',
    moncashMerchantPhone: 'Número MonCash',
    moncashPayerPhone: 'Número desde el que debes enviar',
    moncashToPay: 'Monto a pagar',
    moncashPayWith: 'Pagar con MonCash',
    moncashAutoConfirm: 'Confirmación automática tras el pago MonCash',
    moncashOpenPayment: 'Abrir pago MonCash',
    moncashIPaidVerify: 'Ya pagué — Verificar',
    moncashChecking: 'Comprobando…',
    moncashLinkMissing: 'Falta el enlace de pago MonCash',
    moncashVerifyFailed: 'No se pudo verificar el pago MonCash',
    moncashPaymentConfirmed: '¡Pago MonCash confirmado!',
    moncashPaymentPending: 'Pago aún pendiente',
    moncashRedirecting: 'Redirigiendo a MonCash...',
    moncashContinueOnTracking: '¡Pedido creado! Continúa el pago MonCash en la página de seguimiento.',
    moncashMinPurchaseIs: 'La compra mínima MonCash es de',
    moncashMinShort: 'Mín. MonCash',
    moncashOrderTotal: 'Total del pedido',
    plopplopUssdOption: 'Pague con invitación USSD en su teléfono MonCash — sin página de redirección',
    plopplopUssdHint: 'Se envió una invitación USSD de MonCash a su teléfono. Apruébela y espere la confirmación y entrega automáticas.',
    plopplopUssdNoPromptHint: 'No se envía la invitación USSD si el saldo e-money de MonCash es insuficiente, o si el número es NatCash.',
    plopplopUssdResend: 'Reenviar invitación USSD',
    plopplopUssdResent: 'Se solicitó una nueva invitación USSD de MonCash. Apruébela en el mismo teléfono.',
    plopplopUssdResendFailed: 'No se pudo reenviar la invitación USSD',
    ussdPayPageTitle: 'Pago MonCash USSD',
    ussdPayPageHint: 'Toque Pagar para enviar la invitación USSD. El sistema verifica automáticamente. También puede tocar Ya pagué.',
    ussdPayButton: 'Pagar',
    ussdIPaidButton: 'Ya pagué',
    ussdTxnFromSms: 'Número de transacción MonCash del SMS',
    ussdTxnFromSmsHint: 'Si « Ya pagué » no lo encuentra, escriba el número de transacción del SMS de MonCash y pulse de nuevo.',
    ussdPaySent: 'Invitación USSD enviada. Apruébela en su teléfono MonCash.',
    ussdPayWaiting: 'Esperando la confirmación automática…',
    plopplopPhoneLabel: 'Número de teléfono MonCash',
    plopplopPhoneRequired: 'Ingrese un número MonCash válido (39308318)',
    plopplopRedirectHint: 'Complete el pago en la página segura. Esta pantalla se actualiza sola y luego se entrega el pedido.',
    plopplopCardTitle: 'Tarjeta de débito / crédito',
    plopplopCardDesc: 'Pague con tarjeta de forma segura (USD). Enviamos sus datos automáticamente.',
    plopplopCardHint: 'Complete el pago con tarjeta. El monto se cobra en USD. Esta pantalla se actualiza sola y luego se entrega el pedido.',
    plopplopCardRedirecting: 'Redirigiendo al pago con tarjeta (USD)…',
    plopplopOpenCardPayment: 'Continuar pago con tarjeta',
    plopplopOpenHostedPayment: 'Continuar el pago',
    plopplopPaymentExpired: 'Este pago expiró a los 10 minutos. Haga un nuevo pedido para pagar.',
    plopplopCardAmountHtg: 'Total tarjeta (USD)',
    plopplopCardFee: 'Cargo de tarjeta',
    plopplopCardPayUsd: 'Se cobra en USD',
    plopplopCardAutoConfirm: 'El pago se confirma automáticamente después de pagar.',
    paymentDescription: 'Descripción del pago',
    playerFound: 'Jugador encontrado',
    
    // Categories
    categoryTitle: 'Categorías de productos',
    giftCards: 'Tarjetas de regalo',
    gameTopup: 'Recarga de juegos',
    subscriptions: 'Suscripciones',
    services: 'Servicios',
    crypto: 'Cripto',
    
    // What We Offer
    whatWeOffer: 'Lo que ofrecemos',
    offerSubtitle: 'Elige entre múltiples categorías de productos digitales con entrega inmediata',
    internationalGiftCards: 'Tarjetas de regalo internacionales',
    giftCardsDesc: 'Amazon, Google Play, iTunes, Steam y más',
    automaticGameTopup: 'Recarga automática de juegos',
    gameTopupDesc: 'Free Fire LATAM y Delta Force — entrega instantánea',
    premiumSubscriptions: 'Suscripciones premium',
    subscriptionsDesc: 'Netflix, Spotify, Disney+ y otros servicios',
    digitalServices: 'Servicios digitales',
    servicesDesc: 'Crear cuenta Stripe, verificar PayPal, TextNow',
    
    // Featured Products
    featuredProducts: 'Productos destacados',
    buyNow: 'Comprar ahora',
    addToCart: 'Añadir al carrito',
    viewDetails: 'Ver detalles',
    available: 'Disponible',
    outOfStock: 'Agotado',
    
    // Ready to Start
    readyToStart: '¿Listo para empezar?',
    
    // Auth
    email: 'Correo electrónico',
    password: 'Contraseña',
    fullName: 'Nombre completo',
    confirmPassword: 'Confirmar contraseña',
    dontHaveAccount: '¿No tienes una cuenta?',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    createAccount: 'Crear cuenta',
    gmailYahooOnly: 'Usa un correo de Gmail o Yahoo para crear la cuenta.',
    verifyEmailSent: 'Cuenta creada. Revisa tu correo y verifícalo para continuar.',
    verifyEmailToContinue: 'Verifica tu correo para continuar. Te enviamos un enlace.',
    verifyEmailTitle: 'Verifica tu correo',
    verifyEmailMissingToken: 'Abre el enlace de verificación de tu correo, o vuelve a enviarlo.',
    verifyEmailBanner: 'Verifica tu correo para hacer tu primer pedido.',
    resendVerification: 'Reenviar correo de verificación',
    rememberMe: 'Recordarme',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    orContinueWith: 'o continuar con',
    continueWithGoogle: 'Continuar con Google',
    continueWithTelegram: 'Continuar con Telegram',
    socialLoginStateInvalid: 'La sesión social expiró. Inténtalo de nuevo.',
    resetPassword: 'Restablecer contraseña',
    sendResetLink: 'Enviar enlace de restablecimiento',
    backToLogin: 'Volver al inicio de sesión',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    resetLinkSent: 'Si el correo existe, se ha enviado un enlace de restablecimiento.',
    resetSuccess: 'Contraseña restablecida correctamente. Inicia sesión.',
    tokenMissing: 'El token de restablecimiento falta o no es válido.',
    
    // Cart & Checkout
    yourCart: 'Tu carrito',
    emptyCart: 'Tu carrito está vacío',
    continueShopping: 'Seguir comprando',
    orderSummary: 'Resumen del pedido',
    subtotal: 'Subtotal',
    total: 'Total',
    items: 'artículos',
    checkout: 'Finalizar compra',
    placeOrder: 'Realizar pedido',
    
    // Payment
    paymentMethod: 'Método de pago',
    cryptocurrency: 'Criptomoneda (automático)',
    manualPayment: 'Pago manual',
    cryptoDesc: 'Bitcoin, Ethereum y más',
    manualDesc: 'Transferencia bancaria, otros métodos (se requiere comprobante)',
    
    // Order Tracking
    orderTracking: 'Seguimiento del pedido',
    orderNumber: 'Pedido',
    orderStatus: 'Estado del pedido',
    paymentStatus: 'Estado del pago',
    orderItems: 'Artículos del pedido',
    submitProof: 'Enviar comprobante de pago',
    transactionId: 'ID de transacción',
    proofUrl: 'URL del comprobante',
    uploadProof: 'Subir comprobante',
    
    // Dashboard
    dashboard: 'Panel',
    myOrders: 'Mis pedidos',
    totalOrders: 'Total de pedidos',
    pendingOrders: 'Pedidos pendientes',
    completedOrders: 'Pedidos completados',
    noOrders: 'Aún no tienes pedidos',
    
    // Admin
    manageProducts: 'Gestionar productos',
    manageOrders: 'Gestionar pedidos',
    siteSettings: 'Configuración del sitio',
    addProduct: 'Añadir producto',
    editProduct: 'Editar producto',
    deleteProduct: 'Eliminar producto',
    productName: 'Nombre del producto',
    description: 'Descripción',
    category: 'Categoría',
    price: 'Precio',
    currency: 'Moneda',
    imageUrl: 'URL de la imagen',
    stockAvailable: 'Stock disponible',
    deliveryType: 'Tipo de entrega',
    automatic: 'Automático',
    manual: 'Manual',
    save: 'Guardar',
    cancel: 'Cancelar',
    
    // Settings
    general: 'General',
    apiKeys: 'Claves API',
    appearance: 'Apariencia',
    siteName: 'Nombre del sitio',
    supportEmail: 'Correo de soporte',
    logoUrl: 'URL del logo',
    primaryColor: 'Color principal',
    secondaryColor: 'Color secundario',
    saveSettings: 'Guardar configuración',
    
    // Footer
    aboutUs: 'Sobre nosotros',
    contact: 'Contacto',
    footerCompany: 'Empresa',
    footerCategories: 'Categorías',
    footerSocial: 'Redes',
    footerBlogs: 'Blog',
    footerTagline: 'Tarjetas de regalo, recargas, suscripciones y servicios digitales con entrega rápida.',
    footerSocialComingSoon: 'Pronto en redes sociales.',
    quickLinks: 'Enlaces rápidos',
    support: 'Soporte',
    refundPolicy: 'Política de reembolso',
    privacyPolicy: 'Política de privacidad',
    allRightsReserved: 'Todos los derechos reservados',
    
    // Messages
    loading: 'Cargando...',
    processing: 'Procesando...',
    success: '¡Éxito!',
    error: 'Error',
    loginSuccess: '¡Inicio de sesión exitoso!',
    logoutSuccess: '¡Sesión cerrada correctamente!',
    productAdded: 'Producto añadido al carrito',
    productRemoved: 'Producto eliminado del carrito',
    orderPlaced: '¡Pedido realizado con éxito!',
    proofSubmitted: '¡Comprobante de pago enviado correctamente!',
};

export default es;
